import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { UserIdentityService } from '@shared/core/user-identity.service';
import { Resources } from '@shared/model/permissions';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul>`,
})
export class AppMenu {
    model: MenuItem[] = [];
    billingUrl:string="";   
    constructor( private userIdentityService: UserIdentityService) { }

    ngOnInit() {
        this.billingUrl= location.protocol+"//"+location.hostname.replace("app.","")+"/portal/subscription/manage";
        this.userIdentityService.currentPermissionUpdate$.subscribe((user) => {
            this.buildMenu()
        });
        // this.model = [
        //     {
        //         label: 'Home',
        //         items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
        //     },
        //     {
        //         label: 'UI Components',
        //         items: [
        //             { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
        //             { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
        //             { label: 'Button', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/uikit/button'] },
        //             { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
        //             { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
        //             { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
        //             { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
        //             { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
        //             { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
        //             { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
        //             { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
        //             { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
        //             { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
        //             { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
        //             { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] }
        //         ]
        //     },
        //     {
        //         label: 'Pages',
        //         icon: 'pi pi-fw pi-briefcase',
        //         routerLink: ['/pages'],
        //         items: [
        //             {
        //                 label: 'Landing',
        //                 icon: 'pi pi-fw pi-globe',
        //                 routerLink: ['/landing']
        //             },
        //             {
        //                 label: 'Auth',
        //                 icon: 'pi pi-fw pi-user',
        //                 items: [
        //                     {
        //                         label: 'Login',
        //                         icon: 'pi pi-fw pi-sign-in',
        //                         routerLink: ['/auth/login']
        //                     },
        //                     {
        //                         label: 'Error',
        //                         icon: 'pi pi-fw pi-times-circle',
        //                         routerLink: ['/auth/error']
        //                     },
        //                     {
        //                         label: 'Access Denied',
        //                         icon: 'pi pi-fw pi-lock',
        //                         routerLink: ['/auth/access']
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Crud',
        //                 icon: 'pi pi-fw pi-pencil',
        //                 routerLink: ['/pages/crud']
        //             },
        //             {
        //                 label: 'Not Found',
        //                 icon: 'pi pi-fw pi-exclamation-circle',
        //                 routerLink: ['/pages/notfound']
        //             },
        //             {
        //                 label: 'Empty',
        //                 icon: 'pi pi-fw pi-circle-off',
        //                 routerLink: ['/pages/empty']
        //             }
        //         ]
        //     },
        //     {
        //         label: 'Hierarchy',
        //         items: [
        //             {
        //                 label: 'Submenu 1',
        //                 icon: 'pi pi-fw pi-bookmark',
        //                 items: [
        //                     {
        //                         label: 'Submenu 1.1',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [
        //                             { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 1.2',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Submenu 2',
        //                 icon: 'pi pi-fw pi-bookmark',
        //                 items: [
        //                     {
        //                         label: 'Submenu 2.1',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [
        //                             { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 2.2',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //                     }
        //                 ]
        //             }
        //         ]
        //     },
        //     {
        //         label: 'Get Started',
        //         items: [
        //             {
        //                 label: 'Documentation',
        //                 icon: 'pi pi-fw pi-book',
        //                 routerLink: ['/documentation']
        //             },
        //             {
        //                 label: 'View Source',
        //                 icon: 'pi pi-fw pi-github',
        //                 url: 'https://github.com/primefaces/sakai-ng',
        //                 target: '_blank'
        //             }
        //         ]
        //     }
        // ];
    }
    buildMenu() {
        this.model = [
            {
                label: 'Home',
                items: [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-chart-line', routerLink: ['/dashboard'], visible: this.hasPermission(Resources.Dashboard) },
                    { label: 'Editors', icon: 'pi pi-fw pi-file-edit', routerLink: ['/attributeeditors'], },
                    { label: 'Workflow Stages', icon: 'pi pi-fw pi-cog', routerLink: ['/workflowstages'], },
                    //{ label: 'My Tasks', icon: 'pi pi-briefcase', routerLink: ['/mytasks'] },
                    { label: 'AI Agent', icon: 'pi pi-sparkles', routerLink: ['/aiagent'],visible: this.hasPermission(Resources.Dashboard) }
                ]
            },
            {
                label: 'Inventory',
                items: [
                    { label: 'Product Search', icon: 'fa fa-search', routerLink: ['/inventory/products'], visible: this.hasPermission(Resources.Items) },
                    { label: 'Product Filter', icon: 'fa fa-filter', routerLink: ['/inventory/productsfilter'], visible: this.hasPermission(Resources.Items) },
                    { label: 'Listings', icon: 'fa fa-list-alt', routerLink: ['/inventory/listings'], visible: this.hasPermission(Resources.Listings) },
                    { label: 'Archived products', icon: 'fa fa-box-archive', routerLink: ['/inventory/archived'], visible: this.hasPermission(Resources.ArchivedItems) },
                ]
            },
            {
                label: 'Sales',visible:true,
                items: [
                    { label: 'Report', icon: 'fa fa-balance-scale', routerLink: ['/sales/report'], visible: this.hasPermission(Resources.SalesReport) },
                    { label: 'Summary', icon: 'fa fa-search-plus', routerLink: ['/sales/summary'], visible: this.hasPermission(Resources.SalesExplorer) },
                    { label: 'Daily Sales', icon: 'fa fa-bar-chart', routerLink: ['/sales/dailysales'], visible: this.hasPermission(Resources.DailySales) },
                    {
                        label: 'Buybox followup',icon:'fa fa-life-ring',visible:true,
                        items: [
                            { label: 'Amazon', icon: 'fa-brands fa-amazon', routerLink: ['/sales/amazonneedaction'], visible: this.hasPermission(Resources.AmazonBuybox) },
                            { label: 'Walmart', icon: 'fa fa-snowflake', routerLink: ['/sales/walmartneedaction'], visible: this.hasPermission(Resources.WalmartBuybox) },

                        ]

                    },
                    { label: 'Product Performances', icon: 'fa-solid fa-gauge-high', routerLink: ['/sales/topanalysis'], visible: this.hasPermission(Resources.DailySales) },
                    
                ]
            }, {
                label: 'Shipping',
                items: [
                    { label: 'Orders', icon: 'fa-solid fa-truck-arrow-right', routerLink: ['/sales/shippinglabels'], visible: this.hasPermission(Resources.Orders) },
                    { label: 'Shipping Label', icon: 'pi pi-images', routerLink: ['/sales/shippingbatches'], visible: this.hasPermission(Resources.ShippingLabelPrint) },
                    { label: 'Pending Pick Lists', icon: 'fa fa-clock', routerLink: ['/shipping/pendingbatches'], visible: this.hasPermission(Resources.PickItems) }

                ]
            },{
                label: 'Restock',
                items: [
                   { label: 'Suppliers', icon: 'pi pi-shop', routerLink: ['/purchasing/suppliers'], visible: this.hasPermission(Resources.Suppliers) },

                   { label: 'Ongoing Purchases', icon: 'fa fa-cart-plus', routerLink: ['/purchasing/orders/working'], visible: this.hasPermission(Resources.PurchaseOrder) },
                   { label: 'Purchase History', icon: 'fa fa-history', routerLink: ['/purchasing/orders/completed'], visible: this.hasPermission(Resources.PurchaseOrder) },
                    { label: 'GRN', icon: 'fa fa-cart-arrow-down', routerLink: ['/purchasing/grns'], visible: this.hasPermission(Resources.Grn) },
                    { label: 'GIN', icon: 'pi pi-cart-minus', routerLink: ['/purchasing/gins'], visible: this.hasPermission(Resources.Grn) },
                                        // { label: 'Quatations', icon: 'pi pi-file-excel', routerLink: ['/purchasing/quatations/list'], visible: this.hasPermission(Resources.Suppliers) },
                    // { label: 'Target Prices', icon: 'pi pi-bullseye', routerLink: ['/purchasing/quatations/targetprice'], visible: this.hasPermission(Resources.Suppliers) },
                    // { label: 'Order Distribution', icon: 'pi pi-sliders-h', routerLink: ['/purchasing/quatations/pocomparison'], visible: this.hasPermission(Resources.Suppliers) },
                    // { label: 'PO Finalize', icon: 'pi pi-cart-plus', routerLink: ['/purchasing/quatations/finalize'], visible: this.hasPermission(Resources.Suppliers) },


                   // { label: 'Item Locations', icon: 'fa-solid fa-boxes-stacked', routerLink: ['/purchasing/locations'], visible: this.hasPermission(Resources.Locations) },
                    { label: 'Print Label', icon: 'fa-solid fa-print', routerLink: ['/purchasing/printlabel/null'], visible: this.hasPermission(Resources.Locations) },
                    
                ]
            }, {
                label: 'Quotations',
                items:[
                    { label: 'Quotations', icon: 'pi pi-file-excel', routerLink: ['/purchasing/quatations/list'], visible: this.hasPermission(Resources.Suppliers) },
                    { label: 'Target Prices', icon: 'pi pi-bullseye', routerLink: ['/purchasing/quatations/targetprice'], visible: this.hasPermission(Resources.Suppliers) },
                    { label: 'Order Distribution', icon: 'pi pi-sliders-h', routerLink: ['/purchasing/quatations/pocomparison'], visible: this.hasPermission(Resources.Suppliers) },
                    { label: 'PO Finalize', icon: 'pi pi-cart-plus', routerLink: ['/purchasing/quatations/finalize'], visible: this.hasPermission(Resources.Suppliers) },
                    { label: 'Email Settings', icon: 'pi pi-envelope', routerLink: ['/purchasing/quotation-email-settings'], visible: this.hasPermission(Resources.Suppliers) }
                ]
            },
            {
                label: 'Market Analysis',
                items: [
                    { label: 'Item Analitics', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/market-analysis/itemanalitics'], visible: true },
                ]
            },
            {
                label: 'Warehouse',
                items: [
                    { label: 'Locations', icon: 'fa fa-warehouse', routerLink: ['/inventory/item-locations'], visible: this.hasPermission(Resources.Locations) },
                    { label: 'Inspection', icon: 'fa fa-search', routerLink: ['/inventory/item-location-batch'], queryParams: { type: 'inspection' }, visible: this.hasPermission(Resources.Locations) },
                    { label: 'Audit', icon: 'fa fa-check-double', routerLink: ['/inventory/item-location-batch-a'], queryParams: { type: 'audit' }, visible: this.hasPermission(Resources.Locations) },
                ]
            },
            {
                label: 'Administration',
                items: [
                    { label: 'Work Flows', icon: 'pi pi-fw pi-bars', routerLink: ['/housekeeping/workflow'], visible: this.hasPermission(Resources.Workflow) },
                    { label: 'Attribute Edit Windows', icon: 'pi pi-fw pi-tablet', routerLink: ['/housekeeping/attributeeditwindows'], visible: this.hasPermission(Resources.AttributeEditWindows) },
                    {
                        label: 'Product Settings', icon: 'pi pi-fw pi-cog',visible:true,
                        items: [
                            { label: 'Product Attributes', icon: 'pi pi-fw pi-list', routerLink: ['/housekeeping/productattributes'], visible: this.hasPermission(Resources.ProductAttributes) },
                            { label: 'Attribute Sections', icon: 'pi pi-fw pi-th-large', routerLink: ['/housekeeping/attributesections'], visible: this.hasPermission(Resources.ProductAttributes) },
                            { label: 'Global Parameters', icon: 'pi pi-fw pi-globe', routerLink: ['/housekeeping/globalparams'], visible: this.hasPermission(Resources.GlobalParameters) },
                            { label: 'Categories', icon: 'pi pi-fw pi-box', routerLink: ['/housekeeping/categories'], visible: this.hasPermission(Resources.Categories) },
                        ]

                    },
                    {
                        label: 'User Manager', icon: 'pi pi-fw pi-users',
                        items: [
                            { label: 'Users', icon: 'pi pi-fw pi-user', routerLink: ['/account/users'], visible: this.hasPermission(Resources.Users) },
                            { label: 'User Roles/Permissions', icon: 'pi pi-fw pi-user-plus', routerLink: ['/account/rolepermissions'], visible: this.hasPermission(Resources.Permissions) },
                        ]

                    },
                    { label: 'Intergrations', icon: 'fa fa-puzzle-piece', routerLink: ['/intergrations'], visible: this.hasPermission(Resources.Intergrations) },
                    { label: 'Integrations V2', icon: 'fa fa-puzzle-piece', routerLink: ['/integration-dashboard'], visible: this.hasPermission(Resources.Intergrations) },
                    { label: 'Subscription & Billing', icon: 'fa fa-dollar', url: this.billingUrl, visible: this.hasPermission(Resources.Billing) },
                ]
            }
        ]
        // traverse the model recursively and if non of the children are visible set the parent to not visible
        this.model.forEach(menuItem => {
            this.updateMenuItemVisibility(menuItem);
        });
        

        
    }
    updateMenuItemVisibility(menuItem: MenuItem) {
        if (menuItem.items && menuItem.items.length > 0) {
            menuItem.items.forEach(childItem => this.updateMenuItemVisibility(childItem));
            const anyChildVisible = menuItem.items.some(child => child.visible !== false);
            menuItem.visible = anyChildVisible;
        } else {
            menuItem.visible = menuItem.visible !== false;
        }
    }
    hasPermission(resource: Resources) {
        // debugger;
        var resourceItem = this.userIdentityService.currentPermissionValue?.find(a => a.resource == resource);
        // debugger;
        return !!resourceItem;
        // return false;
    }

    onKeydown(event: KeyboardEvent) {
        const nodeElement = (<HTMLDivElement>event.target);
        if (event.code === 'Enter' || event.code === 'Space') {
            nodeElement.click();
            event.preventDefault();
        }
    }
}
